import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'toDate',
  standalone: true
})
export class ToDatePipe implements PipeTransform {
  transform(value: any): Date | null {
    if (!value) return null;
    
    // Firestore Timestamp with toDate() method
    if (typeof value.toDate === 'function') {
      try {
        return value.toDate();
      } catch {
        return null;
      }
    }
    
    // Already a Date object
    if (value instanceof Date) {
      return isNaN(value.getTime()) ? null : value;
    }
    
    // Number (epoch timestamp in milliseconds or seconds)
    if (typeof value === 'number') {
      return value > 1e11 ? new Date(value) : new Date(value * 1000);
    }
    
    // ISO string or date string
    if (typeof value === 'string') {
      const parsed = new Date(value);
      return isNaN(parsed.getTime()) ? null : parsed;
    }
    
    // Plain object with seconds / nanoseconds from Firestore serialization
    if (value && typeof value === 'object' && typeof value.seconds === 'number') {
      return new Date(value.seconds * 1000);
    }
    
    // Plain object with _seconds (sometimes returned by Admin SDK or custom serializers)
    if (value && typeof value === 'object' && typeof value._seconds === 'number') {
      return new Date(value._seconds * 1000);
    }
    
    return null;
  }
}
